import {
    User,
    Send,
    CloudDownload,
    Printer,
    Sparkles,
    FileText,
    MessageSquareText,
    Paperclip
  } from 'lucide-react';
  import React, { useEffect, useState, useRef} from 'react';
  import Badge from '../UI/Badge';
  import SearchForm from '../UI/SearchForm';
  import Spacing from '../Spacing';
  import Accordion from '../UI/Accordion';
  import Button from '../UI/Button';
  import { fetchSinglePatient, addPatients } from "../../services/patient";
  import { fetchSingleOrder } from "../../services/order";
  import { createOrderComment, getOrderComment, getOrderFiles } from "../../services/order";

  import { exchangeDate, notify, usPhoneFormat } from "../../helpers";
  import Inputmask from 'inputmask';
  import QualityMeasureMessageModal from './QualityMeasureMessageModal';
  import { Drawer } from 'vaul';
  
  export default function OrderSingleViewModal({ children, ...props }) {
    // const location_id = getPractice("location_id");
    // const account_id = getPractice("account_id");
    
    const [messageActiveModal, setMessageActiveModal] = useState(false);  
    const [patientData, setPatientData] = useState({});
    const [activeTab, setActiveTab] = useState(0);  
    const [comments, setComments] = useState([]);
    const [files, setFiles] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null); // Create a ref for the file input
    const dropdownRef = useRef(null);
    
    
    const [data, setData] = useState([]);
    const [filteredConditions, setFilteredConditions] = useState([]);
    const {    
      order_id,
      medmo_order_id,
      reloadData = () => {},
      reloadDataFilter = {},
      messageTemplate = [],
      account_id,
      location_id,
      user_id,
      insuranceOptions,
      activeModal,
      setActiveModal = () => {},
      setSmsLimit = () => {},
      previousScrollPosition = 0
    } = props;


    
    const handleFileChange = (e) => {
      setFile(e.target.files[0]); // Set the selected file
    };
    
  
    const loadData = async (order_id) => {
      const response = await fetchSingleOrder(
        order_id,
        
      );
      if (response) {
        setData(response.data);
        BulkHandleChange(response.data);
  
      }
    };

    const loadComments = async (account_id,medmo_order_id) => {
      const response = await getOrderComment(account_id,medmo_order_id);  // Call API to get comments
      if (response && response.data) {

        const sortedComments = response.data.sort((a, b) =>
          new Date(a.created_at) - new Date(b.created_at)
        );

        setComments(sortedComments);  // Assume the response has a 'comments' field
      }
    };

    const loadFiles = async (account_id,medmo_order_id) => {
      const response = await getOrderFiles(account_id,medmo_order_id);  // Call API to get comments
      if (response && response.data) {

        setFiles(response.data);  // Assume the response has a 'comments' field
      }
    };


    

    const handleAddComment = async () => {
      if (!newComment.trim() && !file) {
        // Ensure either comment text or file is provided
        alert("Please provide a comment or upload a file.");
        return;
      }
      
      const commented = async (account_id, newComment, medmo_order_id) => {
        const response = await createOrderComment(account_id,newComment.trim(), medmo_order_id, file);
        if (response) {
          // setComments([...comments, newComment]);
          setNewComment('');
          setFile(null); 
          if (fileInputRef.current) {
            fileInputRef.current.value = ''; // This clears the file input
          }
          await loadComments(account_id, medmo_order_id); 
          await loadFiles(account_id, medmo_order_id);
        }
      };

      await commented(account_id, newComment, medmo_order_id);
      
      // you can also send a request to your backend to create a new comment
      // and then fetch the updated list of comments
    };

  
  
    const modalStatus = (status) => {   
      setActiveModal(status)
      if (status) { 
        loadData(order_id);
        loadComments(account_id, medmo_order_id);
        loadFiles(account_id, medmo_order_id);

      }   
    };
  
    const defaultValues = {
      account_id: account_id,
      location_id: location_id,
      order_id: order_id,
      first_name: "",
      last_name: "",
      medmo_order_id: "",
      medmo_scan_id: "",
      insurance_plan: "",
      policy_number: "",
      group_number: "",
      icd10: "",
      exam_reason: "",
      scheduling_notes: "",
      additional_notes: "",
      location_name: "",
      status: ""
    };
  
    const [formData, setFormData] = useState(defaultValues);
  
    const handleChange = (e) => {    
      const { name, value } = e.target; 
      if (name === "mobile_phone") {               
        const phoneInputs = document.querySelectorAll('.us_phone');
        Inputmask({
            mask: '(999) 999-9999',
            showMaskOnHover: false,
            showMaskOnFocus: true,
        }).mask(phoneInputs);
      }
      setFormData({
        ...formData,
        [name]: value
      });
    };
  
    const BulkHandleChange = (db_data) => {
      const newData = {};
      Object.keys(defaultValues).forEach(key => {
        let value = "";     
  
        // let lastVisit = careGapsLatestCompletedDos(db_data?.care_gaps);        
        if (key === "insurance_id") { 
          value = db_data?.insurance.id;         
        } else if (key === "risk_level") { 
          value = db_data?.risk_level; 
        } else { 
          value = db_data[key]; 
        }   
        if (key === "mobile_phone") {
          if (value === null) {
            value = db_data["home_phone"];
          } 
          const phoneInputs = document.querySelectorAll('.us_phone');
          Inputmask({
              mask: '(999) 999-9999',
              showMaskOnHover: false,
              showMaskOnFocus: true,
          }).mask(phoneInputs);
        }
        if (value === null) { 
          value = "";
        }     
        newData[key] = value; // Collect key-value pairs in newData
      });
      // Update formData once with all the collected data
      setFormData(newData);
  
  };
  
    useEffect(() => {
      setFormData({
        ...formData,
        location_id: location_id,
        account_id: account_id,
        order_id : order_id
      })
      modalStatus(activeModal)
    }, [location_id, account_id, order_id]);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
     
      e.target.disabled = true;
      const response = await addPatients(formData);
       
      if (response.detail) {
        notify('error', response.detail);
      } else { 
        reloadData(reloadDataFilter);
        notify("success", response?.data?.message);
        setActiveModal(!activeModal);
        window.scrollTo(0, previousScrollPosition);
      } 
      e.target.disabled = false;   
  
    };
  
    const handleFilterConditions = (chronicConditions) => {
      const filteredData = chronicConditions.reduce((acc, condition) => {
        if (!acc.some(c => c.name.includes("Type 2 Diabetes")) || !condition.name.includes("Type 2 Diabetes"))
          acc.push({ ...condition, name: condition.name.includes("Type 2 Diabetes") ? "Type 2 Diabetes" : condition.name });
        return acc;
      }, []);
      setFilteredConditions(filteredData);
    };
  
  
    const handleSendMessageModal = (data) => {
      setPatientData(data)
      setMessageActiveModal(!messageActiveModal);
    }
    
    const medmoComments = comments.filter((comment) => comment.CommentType === "From Medmo");
    const otherComments = comments.filter((comment) => comment.CommentType !== "From Medmo");

    const prescriptionFiles = files.filter(file => file.prescription);
    const nonPrescriptionFiles = files.filter(file => !file.prescription);

    const handleDrawerClose = () => {
      setActiveModal(false);
      window.scrollTo(0, previousScrollPosition);
    };

    return (
      <>
        <div style={{ height: "100%" }} ref={dropdownRef}>
          <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
            <Drawer.Trigger style={{ height: '100%' }} onClick={() => modalStatus(!activeModal)}>
            {" "}{children}{" "}
            </Drawer.Trigger>
            <Drawer.Portal>
              <Drawer.Overlay className="docpro_drawer_overlay"/>
              <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
                <Drawer.Title className="sr-only">Patient Details</Drawer.Title>
                <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
                <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
        
                  <div className="docpro_modal">
                    {data?.length === 0 ? (
                      <div
                        style={{
                          height: "300px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Loading...
                      </div>
                    ) : (
                      <>
                        <form onSubmit={handleSubmit}>
                          <div className="docpro_patient_head">
                            <div className="docpro_media">
                              <img src="/images/avatar.png" alt="Avatar" />
                              <div className="docpro_media_right">
                                <h2 className="docpro_fs_24">
                                  {data?.last_name + " " + data?.first_name}
                                </h2>

                              
                              </div>
                            </div>
                            <div className="docpro_bordered_btns">
                              {/* <MessageModal
                                last_name={data?.last_name}                    
                                first_name={data?.first_name}                    
                                phone={data?.mobile_phone} 
                                class_name="docpro_icon_btn_2 docpro_primary_color"
                              /> */}
        
                              {/* <button
                                className="docpro_icon_btn_2 docpro_primary_color"
                                type="button"
                              >
                                <CloudDownload />
                              </button>
                              <button
                                className="docpro_icon_btn_2 docpro_primary_color"
                                type="button"
                              >
                                <Printer />
                              </button> */}
                              
                            </div>
                          </div>
                          <Spacing lg="20" sm="20" />
                          <div className="docpro_tab">
                            <button
                              type="button"
                              className={`docpro_tab_item ${
                                activeTab === 0 ? "active" : ""
                              }`}
                              onClick={() => setActiveTab(0)}
                            >
                              <User width={15} height={15} /> Order Info
                            </button>
                            <button
                              type="button"
                              className={`docpro_tab_item ${
                                activeTab === 1 ? "active" : ""
                              }`}
                              onClick={() => setActiveTab(1)}
                            >
                              <FileText width={15} height={15} /> Files
                            </button>
                          </div>
                          <hr />
                          <Spacing lg="20" sm="20" />
                          {activeTab === 0 && (
                            <>
                              <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 ">
                                    Last Name{" "}
                                    <span className="docpro_red_color">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="last_name"
                                    required
                                    readOnly
                                    defaultValue={formData?.last_name}
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 ">
                                    First Name{" "}
                                    <span className="docpro_red_color">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="first_name"
                                    required
                                    readOnly
                                    defaultValue={formData?.first_name}
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 ">
                                    Medmo Order Id{" "}
                                    <span className="docpro_red_color">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="medmo_order_id"
                                    placeholder=""
                                    required
                                    readOnly
                                    defaultValue={formData?.medmo_order_id}
                                  />
                                </div>
        
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 ">
                                    Medmo Scan Id <span className="docpro_red_color">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg us_phone"
                                    name="medmo_scan_id"
                                    required
                                    readOnly
                                    defaultValue={formData?.medmo_scan_id}
                                    maxLength={20}
                                    placeholder=""
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 ">Insurance Plan <span className="docpro_red_color">*</span></label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    placeholder=""
                                    required
                                    readOnly
                                    defaultValue={formData?.insurance_plan}
                                  />
                                </div>
        
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Policy Number
                                  </label>
                                  <input
                                    type="email"
                                    className="docpro_form_field size_lg"
                                    name="policy_number"
                                    onChange={handleChange}
                                    value={formData?.policy_number}
                                  />
                                </div>
        
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Group Number
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="group_number"                            
                                    onChange={handleChange}
                                    value={formData?.group_number}
                                  />
                                </div>
        
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    ICD10
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="icd10"                            
                                    onChange={handleChange}
                                    value={formData?.icd10}
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Exam Reason
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="exam_reason"                            
                                    onChange={handleChange}
                                    value={formData?.exam_reason}
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                  Scheduling Notes
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="scheduling_notes"                            
                                    onChange={handleChange}
                                    value={formData?.scheduling_notes}
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                  Additional Notes
                                  </label>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="additional_notes"                            
                                    onChange={handleChange}
                                    value={formData?.additional_notes}
                                  />
                                </div>

        
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Location
                                  </label>
                                  <input
                  
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="location"
                                    placeholder=""
                                    required
                                    readOnly
                                    defaultValue={formData?.location_name}
                                  />
                                </div>
                                <div className="docpro_grid_item">
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Status
                                  </label>
                                  <input
                  
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    name="status"
                                    placeholder=""
                                    required
                                    readOnly
                                    defaultValue={formData?.status}
                                  />
                                </div>
                              </div>
        
                              <Spacing lg="36" sm="36" />
                              <hr />

                              <div className="docpro_grid_item">
                                <label className="docpro_fw_500 docpro_primary_color">Activities</label>
                                <div className="docpro_chat_container" style={{ maxHeight: "400px", overflowY: "auto", marginBottom: "20px" }}>
                                  {comments.map((comment, index) => (
                                    <div
                                      key={index}
                                      className={`docpro_chat_bubble ${
                                        comment.comment_type && comment.comment_type.includes("From Client") ? "docpro_chat_client" : "docpro_chat_medmo"
                                      }`}
                                    >
                                      {comment.comment ? (
                                        <p className="docpro_chat_text">{comment.comment}</p>
                                      ) : comment.file_url ? (
                                        <a
                                          href={comment.file_url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="docpro_chat_text"
                                          style={{ color: "#007bff", textDecoration: "none" }}
                                        >
                                          <FileText width={20} height={20} /> {comment.filename}
                                        </a>
                                      ) : (
                                        <p className="docpro_chat_text">No comment provided.</p>
                                      )}
                                      <span className="docpro_chat_timestamp">
                                        {new Date(comment.created_at).toLocaleString()}
                                      </span>
                                    </div>
                                  ))}
                                </div>

                                <div className="docpro_chat_box" style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                  <input
                                    type="text"
                                    className="docpro_form_field size_lg"
                                    placeholder={file ? `Attached: ${file.name}` : "Type a comment..."}
                                    value={file ? "" : newComment}
                                    onChange={(e) => !file && setNewComment(e.target.value)}
                                    disabled={!!file} 
                                    style={{ flex: 1, marginRight: "10px" }}
                                  />
                                  <label
                                    htmlFor="fileInput"
                                    className="docpro_attach_file_button"
                                    style={{
                                      display: "inline-block",
                                      padding: "6px 12px",
                                      backgroundColor: "#f1f1f1",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <Paperclip width={20} height={20} />
                                  </label>
                                  <input
                                    type="file"
                                    id="fileInput"
                                    className="docpro_form_field size_lg"
                                    onChange={handleFileChange}
                                    style={{ display: "none" }} // Hide the actual file input
                                  />
                                </div>
                                

                                <div style={{ textAlign: "right" }}>
                                  <button
                                    type="button"
                                    onClick={handleAddComment}
                                    className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn"
                                    style={{ display: "flex", alignItems: "center", gap: "5px" }}
                                  >
                                    <Send width={20} height={20} />
                                    <span>Send</span>
                                  </button>
                                </div>
                              </div>
                              {/* <Spacing lg="36" sm="36" />
                              <div className="docpro_grid docpro_grid_col_6 docpro_grid_gap_2">
                                {data?.chronic_conditions &&
                                data?.chronic_conditions.length > 0 ? (
                                  data?.chronic_conditions?.map(
                                    (item, index) => (
                                      <div className="docpro_grid_item" key={item.id}>
                                        <div className="docpro_border_box">
                                          {item.name}
                                        </div>
                                      </div>
                                    )
                                  )
                                ) : (
                                  <div className="no_data">No data available</div>
                                )}
                              </div> */}
        
                  
                            </>
                          )}
                          {activeTab === 1 && (
                            <>
                              <div className="docpro_grid_item">
                                <div className="docpro_file_container">
                                  <h3 className="docpro_fs_18 docpro_mb_0" style={{ marginBottom: '10px' }}>Uploaded Files</h3>
                                  {nonPrescriptionFiles.length > 0 ? (
                                    <>
                                      <div className="docpro_file_explorer">
                                        {nonPrescriptionFiles.map((file, index) => (
                                          <a key={index} href={file.file_url} target="_blank" rel="noopener noreferrer" className="docpro_file_item" title={file.filename}>
                                            <div className="file_icon">
                                              <FileText width={20} height={20} />
                                            </div>
                                            <span className="file_name" title={file.filename}>{file.filename}</span>
                                          </a>
                                        ))}
                                      </div>
                                    </>
                                  ) : (
                                    <p>No Uploaded Files available</p>
                                  )}

                                  <h3 className="docpro_fs_18 docpro_mb_0" style={{ marginTop: '20px', marginBottom: '10px' }}>E-Prescription</h3>
                                  {prescriptionFiles.length > 0 ? (
                                    <>
                                      <div className="docpro_file_explorer">
                                        {prescriptionFiles.map((file, index) => (
                                          <a key={index} href={file.file_url} target="_blank" rel="noopener noreferrer" className="docpro_file_item" title={file.filename}>
                                            <div className="file_icon">
                                              <FileText width={20} height={20} />
                                            </div>
                                            <span className="file_name" title={file.filename}>{file.filename}</span>
                                          </a>
                                        ))}
                                      </div>
                                    </>
                                  ) : null}

                                  {prescriptionFiles.length === 0 && nonPrescriptionFiles.length === 0 && (
                                    <p>No files available</p>
                                  )}
                                </div>
                              </div>
                            </>
                          )}



                          {activeTab === 2 && (
                            <>
                              <label className="docpro_fw_500 docpro_primary_color">
                                Order Info
                              </label>
                              <div className="docpro_sp_section_1 docpro_primary_color">
                                <div>
                                  <div className="docpro_table_1">
                                    <div className="docpro_table_responsive">
                                      <table className="docpro_mb_0 docpro_primary_color">
                                        <tbody className="docpro_vertical_align">
                                          <tr>
                                            <td
                                              className="docpro_fw_500"
                                              style={{ width: "35%", borderTop: "0px" }}
                                            >
                                              First Name
                                            </td>
                                            <td style={{ borderTop: "0px" }}>Diaz</td>
                                          </tr>
                                          <tr>
                                            <td
                                              className="docpro_fw_500"
                                              style={{ width: "35%" }}
                                            >
                                              Last Name
                                            </td>
                                            <td>Angelisa</td>
                                          </tr>
                                          <tr>
                                            <td
                                              className="docpro_fw_500"
                                              style={{ width: "35%" }}
                                            >
                                              DOB
                                            </td>
                                            <td>12/23/1992</td>
                                          </tr>
                                          <tr>
                                            <td
                                              className="docpro_fw_500"
                                              style={{ width: "35%" }}
                                            >
                                              Phone
                                            </td>
                                            <td>+3451231234</td>
                                          </tr>
                                          <tr>
                                            <td
                                              className="docpro_fw_500"
                                              style={{ width: "35%" }}
                                            >
                                              Insurance
                                            </td>
                                            <td>Blue Cross Blue Shield</td>
                                          </tr>
                                          <tr>
                                            <td
                                              className="docpro_fw_500"
                                              style={{ width: "35%" }}
                                            >
                                              Insurance ID
                                            </td>
                                            <td>567845</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Referral
                                  </label>
                                  <div className="docpro_radio_group">
                                    <div className="docpro_radio">
                                      <input type="radio" name="referral" />
                                      <label style={{ paddingLeft: "30px" }}>Yes</label>
                                    </div>
                                    <div className="docpro_radio">
                                      <input type="radio" name="referral" />
                                      <label style={{ paddingLeft: "30px" }}>No</label>
                                    </div>
                                  </div>
                                  <Spacing lg="20" sm="20" />
                                  <label className="docpro_fw_500 docpro_primary_color">
                                    Medication
                                  </label>
                                  <div className="docpro_radio_group">
                                    <div className="docpro_radio">
                                      <input type="radio" name="medication" />
                                      <label style={{ paddingLeft: "30px" }}>Yes</label>
                                    </div>
                                    <div className="docpro_radio">
                                      <input type="radio" name="medication" />
                                      <label style={{ paddingLeft: "30px" }}>No</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Spacing lg="36" sm="36" />
                              <label className="docpro_fw_500 docpro_primary_color">
                                Visit type
                              </label>
                              <select className="docpro_form_field size_lg">
                                <option value="1">DOT Physical</option>
                                <option value="2">DOT Physical</option>
                                <option value="3">DOT Physical</option>
                                <option value="4">DOT Physical</option>
                              </select>
                              <Spacing lg="16" sm="16" />
                              <label className="docpro_fw_500 docpro_primary_color">
                                Reason for visit
                              </label>
                              <SearchForm variant="size_lg" />
                              <Accordion title="Abdomainal Distension (Gaseous)">
                                <div className="docpro_grid docpro_grid_gap_20 docpro_grid_col_2">
                                  <div className="docpro_grid_item">
                                    <label className="docpro_fw_500 docpro_primary_color">
                                      Duration
                                    </label>
                                    <div className="docpro_form_field_group">
                                      <input
                                        type="text"
                                        className="docpro_form_field size_lg"
                                      />
                                      <select className="docpro_form_field size_lg">
                                        <option value={1}>Days</option>
                                        <option value={2}>1</option>
                                        <option value={3}>2</option>
                                        <option value={4}>3</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="docpro_grid_item">
                                    <label className="docpro_fw_500 docpro_primary_color">
                                      Onset
                                    </label>
                                    <select className="docpro_form_field size_lg">
                                      <option value="1">Onset</option>
                                      <option value="2">Onset 1</option>
                                      <option value="3">Onset 2</option>
                                    </select>
                                  </div>
                                </div>
                                <Spacing lg="20" sm="20" />
                                <textarea
                                  cols="30"
                                  rows="2"
                                  className="docpro_form_field"
                                ></textarea>
                              </Accordion>
                            </>
                          )}
                        </form>
                      </>
                    )}
                  </div>
                </div>
              </Drawer.Content>
            </Drawer.Portal>
          </Drawer.Root>
        </div>
        {messageActiveModal && (
          <QualityMeasureMessageModal
            last_name={formData?.last_name}
            first_name={formData?.first_name}
            phone={usPhoneFormat(formData?.mobile_phone)}
            template_type={patientData?.name}
            messageTemplate={messageTemplate}
            account_id={account_id}
            location_id={location_id}
            activeModal={messageActiveModal}
            setActiveModal={setMessageActiveModal}
            setSmsLimit={setSmsLimit}
            previousScrollPosition={previousScrollPosition}
          />
        )}
      </>
    );
  }